import {Polygon} from './polygon';
import {Spot} from './spot';

export class GeoGroupData {
  id = '';
  projectId = '';
  name = '';
  description = '';
  createdOn = Date.now();
  updatedOn = Date.now();
  color = '';
  showBounds = false;
}
